import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { DocumentsState, selectDocumentsState } from '../documents-selectors';
import { OfferingDocumentsState } from './offerings-types';

export const getOfferingDocumentsState:any = createDraftSafeSelector(
  selectDocumentsState,
  (state: DocumentsState) => {
    return state.offerings;
  }
);
export const getOfferingDocuments:any = createDraftSafeSelector(
  getOfferingDocumentsState,
  (state: OfferingDocumentsState) => {
    return state.offerings;
  }
);
